// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/Values_01.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
}

@media only screen and (max-device-width: 768px) {
  .news-header-text .section-item-2 {
    width: 30%;
    padding: 0px 60px 0px 0px;
 }
  .news-article {
    gap: 16px;
 }
  .news-article .article-card .article-img-box .article-img {
   
 }
  .news-article .article-card .article-button-group {
    display: block;
    position: absolute;
    right: 16px;
    bottom: 16px;
 }
  .news-article .article-card .article-button-group .article-button {
    border-radius: 10px;
 }
  .member-name {
    padding: 16px 0px 0px 0px;
 }
  .past-event {
    gap: 16px;
 }
  .past-event .pastEvent-card .pastEvent-button-group {
    display: block;
    position: absolute;
    right: 16px;
    bottom: 16px;
 }
  .react-photo-album--image {
    border-radius: 20px;
 }
}
@media only screen and (max-device-width: 480px) {
  .player-wrapper{
    width: calc(100% - 60px);
  }
  .video-player {

    video{
      border-radius: 10px;
    }
}
  .section-news-shadow {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background: #fcfcfc;
   /* Card Shadow */
    box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);
 }
  .section-event-shadow {
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
   /* Card Shadow */
    box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);
 }
  .section-news-header {
    display: block;
    padding: 60px 0px 30px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .news-header-text {
    width: 100%;
    display: block;
 }
  .news-header-text .section-item-1 {
    width: calc(100% - 60px);
    padding: 0px 30px;
 }
  .news-header-text .section-item-2 {
    width: calc(100% - 60px);
    padding: 30px;
 }
  .news-header-image {
    display: block;
    max-width: 1366px;
    padding: 0px 0px 0px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .news-header-image .news-header-image-group {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
 }
  .news-header-image .header-img {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
   /* <------ */
    background-repeat: no-repeat;
    background-position: center center;
    width: calc(100% - 60px);
    height: 480px;
    border-radius: 10px;
    margin-left: auto;
    margin-right: auto;
 }
  .section-news {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: auto;
    text-align: center;
    padding: 60px 0px 0px 0px;
 }
  .section-news-text {
    width: calc(100% - 120px);
    display: block;
    justify-content: center;
    align-items: center;
    padding: 0px 60px;
 }
  .section-news-text .section-tag {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
 }
  .section-news-text .section-title {
    width: 100%;
    text-transform: uppercase;
 }
  .news-article {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    overflow: auto;
    margin-left: auto;
    margin-right: auto;
 }
  .news-article .article-card {
    width: 100%;
    display: block;
    margin-top: 0px;
    text-align: left;
    position: relative;
 }
  .news-article .article-card .article-img-box {
    border-radius: 10px;
    background: #ecebe5;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: unset;
    width: 100%;
 }
  .news-article .article-card .article-img-box .article-img {
    width: 100%;
    
 }
  .news-article .article-card .article-button-group {
    display: block;
    position: absolute;
    right: unset;
    left: 16px;
    bottom: 16px;
 }
  .news-article .article-card .article-button-group .article-button {
    border-radius: 10px;
    padding: 10px 12px;
 }
  .news-article .article-card .team-member-info {
    padding: 16px 20px 0px 20px;
 }
  .member-name {
    padding: 16px 0px 0px 0px;
 }
  .section-news-content {
    text-align: center;
    padding: 30px 0px;
 }
  .tab-title {
    width: 100%;
    display: flex;
    justify-content: center;
 }
  .tab-title-group {
    display: flex;
    height: 60px;
    padding: 4px;
    align-items: center;
    text-align: center;
    width: fit-content;
    background-color: #eee;
    border-radius: 30px;
    max-width: 100%;
    overflow: auto;
 }
  .tab-content {
    padding: 30px;
 }
  .button-tab {
    display: flex;
    padding: 20px 12px;
    justify-content: center;
    align-items: center;
    gap: 4px;
    border-radius: 30px;
    border: 0px;
 }
  .button-tab:hover {
    transform: scale(1.1);
    transition: transform 0.5s ease;
 }
  .button-tab.activeTab {
    border-radius: 30px;
    background: #cbbaa6;
 }
  .section-event {
    display: block;
    max-width: 1366px;
    padding: 60px 0px 30px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .event-header-text {
    width: 100%;
    display: flex;
 }
  .event-header-text .section-item-1 {
    width: 100%;
    padding: 0px 30px 30px 30px;
 }
  .event-header-image {
    display: block;
    max-width: 1366px;
    padding: 0px 0px 60px 0px;
    margin-left: auto;
    margin-right: auto;
 }
  .event-header-image .event-header-image-group {
    width: calc(100% - 60px);
    margin-left: auto;
    margin-right: auto;
 }
  .event-header-image .header-img {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-size: cover;
   /* <------ */
    background-repeat: no-repeat;
    background-position: center center;
    width: 100%;
    height: 480px;
    border-radius: 10px;
 }
  .section-past-event {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: auto;
    text-align: left;
    padding: 0px 30px;
 }
  .section-past-event .section-tag {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: flex-start;
 }
  .section-past-event .section-title {
    width: 100%;
    text-transform: uppercase;
 }
  .section-past-event-content {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: auto;
    text-align: center;
    padding: 30px 0px;
 }
  .past-event {
    display: grid;
    grid-template-columns: 1fr;
    gap: 24px;
    overflow: auto;
    margin-left: auto;
    margin-right: auto;
 }
  .past-event .pastEvent-card {
    width: 100%;
    display: block;
    text-align: left;
    position: relative;
 }
  .past-event .pastEvent-card .pastEvent-img-box {
    border-radius: 10px;
    min-height: 200px;
    background: #d3d1c5;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    height: unset;
    width: 100%;
 }
  .past-event .pastEvent-card .pastEvent-img-box .pastEvent-img {
    width: 100%;
    border-radius: 10px;
 }
  .past-event .pastEvent-card .pastEvent-button-group {
    display: block;
    position: absolute;
    right: 30px;
    left: 16px;
    bottom: 16px;
 }
  .past-event .pastEvent-card .pastEvent-button-group .pastEvent-button {
    padding: 10px 12px;
    border-radius: 10px;
    border: 1px solid #ecebe6;
    color: #fcfcfc;
    background: rgba(252, 252, 252, 0.2);
    backdrop-filter: blur(10px);
 }
  .past-event .pastEvent-card .pastEvent-title-group {
    padding: 16px 0px 0px 0px;
    display: flex;
    flex-direction: column-reverse;
 }
  .section-gallery {
    display: block;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: auto;
    text-align: center;
    padding: 60px 0px;
 }
}
`, "",{"version":3,"sources":["webpack://./src/assets/style/news_mobile.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;;AAEA;EACE;IACE,UAAU;IACV,yBAAyB;CAC5B;EACC;IACE,SAAS;CACZ;EACC;;CAED;EACC;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf;EACC;IACE,mBAAmB;CACtB;EACC;IACE,yBAAyB;CAC5B;EACC;IACE,SAAS;CACZ;EACC;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,YAAY;CACf;EACC;IACE,mBAAmB;CACtB;AACD;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;;IAEE;MACE,mBAAmB;IACrB;AACJ;EACE;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,mBAAmB;GACpB,gBAAgB;IACf,kNAAkN;CACrN;EACC;IACE,+BAA+B;IAC/B,gCAAgC;GACjC,gBAAgB;IACf,kNAAkN;CACrN;EACC;IACE,cAAc;IACd,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,cAAc;CACjB;EACC;IACE,wBAAwB;IACxB,iBAAiB;CACpB;EACC;IACE,wBAAwB;IACxB,aAAa;CAChB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,mDAA2C;IAC3C,sBAAsB;GACvB,YAAY;IACX,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;IACxB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;CAC5B;EACC;IACE,yBAAyB;IACzB,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;CACpB;EACC;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,uBAAuB;CAC1B;EACC;IACE,WAAW;IACX,yBAAyB;CAC5B;EACC;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;CACrB;EACC;IACE,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;CACd;EACC;IACE,WAAW;;CAEd;EACC;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,YAAY;CACf;EACC;IACE,mBAAmB;IACnB,kBAAkB;CACrB;EACC;IACE,2BAA2B;CAC9B;EACC;IACE,yBAAyB;CAC5B;EACC;IACE,kBAAkB;IAClB,iBAAiB;CACpB;EACC;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;CAC1B;EACC;IACE,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,cAAc;CACjB;EACC;IACE,aAAa;CAChB;EACC;IACE,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,WAAW;CACd;EACC;IACE,qBAAqB;IACrB,+BAA+B;CAClC;EACC;IACE,mBAAmB;IACnB,mBAAmB;CACtB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,aAAa;CAChB;EACC;IACE,WAAW;IACX,2BAA2B;CAC9B;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,mDAA2C;IAC3C,sBAAsB;GACvB,YAAY;IACX,4BAA4B;IAC5B,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,mBAAmB;CACtB;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;CACpB;EACC;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,2BAA2B;CAC9B;EACC;IACE,WAAW;IACX,yBAAyB;CAC5B;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;CACpB;EACC;IACE,aAAa;IACb,0BAA0B;IAC1B,SAAS;IACT,cAAc;IACd,iBAAiB;IACjB,kBAAkB;CACrB;EACC;IACE,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,kBAAkB;CACrB;EACC;IACE,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,WAAW;CACd;EACC;IACE,WAAW;IACX,mBAAmB;CACtB;EACC;IACE,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,YAAY;CACf;EACC;IACE,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,oCAAoC;IACpC,2BAA2B;CAC9B;EACC;IACE,yBAAyB;IACzB,aAAa;IACb,8BAA8B;CACjC;EACC;IACE,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,iBAAiB;CACpB;AACD","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n\n@media only screen and (max-device-width: 768px) {\n  .news-header-text .section-item-2 {\n    width: 30%;\n    padding: 0px 60px 0px 0px;\n }\n  .news-article {\n    gap: 16px;\n }\n  .news-article .article-card .article-img-box .article-img {\n   \n }\n  .news-article .article-card .article-button-group {\n    display: block;\n    position: absolute;\n    right: 16px;\n    bottom: 16px;\n }\n  .news-article .article-card .article-button-group .article-button {\n    border-radius: 10px;\n }\n  .member-name {\n    padding: 16px 0px 0px 0px;\n }\n  .past-event {\n    gap: 16px;\n }\n  .past-event .pastEvent-card .pastEvent-button-group {\n    display: block;\n    position: absolute;\n    right: 16px;\n    bottom: 16px;\n }\n  .react-photo-album--image {\n    border-radius: 20px;\n }\n}\n@media only screen and (max-device-width: 480px) {\n  .player-wrapper{\n    width: calc(100% - 60px);\n  }\n  .video-player {\n\n    video{\n      border-radius: 10px;\n    }\n}\n  .section-news-shadow {\n    border-bottom-left-radius: 30px;\n    border-bottom-right-radius: 30px;\n    background: #fcfcfc;\n   /* Card Shadow */\n    box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);\n }\n  .section-event-shadow {\n    border-bottom-left-radius: 30px;\n    border-bottom-right-radius: 30px;\n   /* Card Shadow */\n    box-shadow: 0px 638px 179px 0px rgba(0, 0, 0, 0), 0px 408px 163px 0px rgba(0, 0, 0, 0.01), 0px 230px 138px 0px rgba(0, 0, 0, 0.04), 0px 102px 102px 0px rgba(0, 0, 0, 0.07), 0px 26px 56px 0px rgba(0, 0, 0, 0.08);\n }\n  .section-news-header {\n    display: block;\n    padding: 60px 0px 30px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .news-header-text {\n    width: 100%;\n    display: block;\n }\n  .news-header-text .section-item-1 {\n    width: calc(100% - 60px);\n    padding: 0px 30px;\n }\n  .news-header-text .section-item-2 {\n    width: calc(100% - 60px);\n    padding: 30px;\n }\n  .news-header-image {\n    display: block;\n    max-width: 1366px;\n    padding: 0px 0px 0px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .news-header-image .news-header-image-group {\n    width: 100%;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .news-header-image .header-img {\n    background: url(\"../images/Values_01.webp\");\n    background-size: cover;\n   /* <------ */\n    background-repeat: no-repeat;\n    background-position: center center;\n    width: calc(100% - 60px);\n    height: 480px;\n    border-radius: 10px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .section-news {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: auto;\n    text-align: center;\n    padding: 60px 0px 0px 0px;\n }\n  .section-news-text {\n    width: calc(100% - 120px);\n    display: block;\n    justify-content: center;\n    align-items: center;\n    padding: 0px 60px;\n }\n  .section-news-text .section-tag {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n }\n  .section-news-text .section-title {\n    width: 100%;\n    text-transform: uppercase;\n }\n  .news-article {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 24px;\n    overflow: auto;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .news-article .article-card {\n    width: 100%;\n    display: block;\n    margin-top: 0px;\n    text-align: left;\n    position: relative;\n }\n  .news-article .article-card .article-img-box {\n    border-radius: 10px;\n    background: #ecebe5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: unset;\n    width: 100%;\n }\n  .news-article .article-card .article-img-box .article-img {\n    width: 100%;\n    \n }\n  .news-article .article-card .article-button-group {\n    display: block;\n    position: absolute;\n    right: unset;\n    left: 16px;\n    bottom: 16px;\n }\n  .news-article .article-card .article-button-group .article-button {\n    border-radius: 10px;\n    padding: 10px 12px;\n }\n  .news-article .article-card .team-member-info {\n    padding: 16px 20px 0px 20px;\n }\n  .member-name {\n    padding: 16px 0px 0px 0px;\n }\n  .section-news-content {\n    text-align: center;\n    padding: 30px 0px;\n }\n  .tab-title {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n }\n  .tab-title-group {\n    display: flex;\n    height: 60px;\n    padding: 4px;\n    align-items: center;\n    text-align: center;\n    width: fit-content;\n    background-color: #eee;\n    border-radius: 30px;\n    max-width: 100%;\n    overflow: auto;\n }\n  .tab-content {\n    padding: 30px;\n }\n  .button-tab {\n    display: flex;\n    padding: 20px 12px;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    border-radius: 30px;\n    border: 0px;\n }\n  .button-tab:hover {\n    transform: scale(1.1);\n    transition: transform 0.5s ease;\n }\n  .button-tab.activeTab {\n    border-radius: 30px;\n    background: #cbbaa6;\n }\n  .section-event {\n    display: block;\n    max-width: 1366px;\n    padding: 60px 0px 30px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .event-header-text {\n    width: 100%;\n    display: flex;\n }\n  .event-header-text .section-item-1 {\n    width: 100%;\n    padding: 0px 30px 30px 30px;\n }\n  .event-header-image {\n    display: block;\n    max-width: 1366px;\n    padding: 0px 0px 60px 0px;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .event-header-image .event-header-image-group {\n    width: calc(100% - 60px);\n    margin-left: auto;\n    margin-right: auto;\n }\n  .event-header-image .header-img {\n    background: url(\"../images/Values_01.webp\");\n    background-size: cover;\n   /* <------ */\n    background-repeat: no-repeat;\n    background-position: center center;\n    width: 100%;\n    height: 480px;\n    border-radius: 10px;\n }\n  .section-past-event {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: auto;\n    text-align: left;\n    padding: 0px 30px;\n }\n  .section-past-event .section-tag {\n    width: 100%;\n    text-align: center;\n    display: flex;\n    justify-content: flex-start;\n }\n  .section-past-event .section-title {\n    width: 100%;\n    text-transform: uppercase;\n }\n  .section-past-event-content {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: auto;\n    text-align: center;\n    padding: 30px 0px;\n }\n  .past-event {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 24px;\n    overflow: auto;\n    margin-left: auto;\n    margin-right: auto;\n }\n  .past-event .pastEvent-card {\n    width: 100%;\n    display: block;\n    text-align: left;\n    position: relative;\n }\n  .past-event .pastEvent-card .pastEvent-img-box {\n    border-radius: 10px;\n    min-height: 200px;\n    background: #d3d1c5;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    height: unset;\n    width: 100%;\n }\n  .past-event .pastEvent-card .pastEvent-img-box .pastEvent-img {\n    width: 100%;\n    border-radius: 10px;\n }\n  .past-event .pastEvent-card .pastEvent-button-group {\n    display: block;\n    position: absolute;\n    right: 30px;\n    left: 16px;\n    bottom: 16px;\n }\n  .past-event .pastEvent-card .pastEvent-button-group .pastEvent-button {\n    padding: 10px 12px;\n    border-radius: 10px;\n    border: 1px solid #ecebe6;\n    color: #fcfcfc;\n    background: rgba(252, 252, 252, 0.2);\n    backdrop-filter: blur(10px);\n }\n  .past-event .pastEvent-card .pastEvent-title-group {\n    padding: 16px 0px 0px 0px;\n    display: flex;\n    flex-direction: column-reverse;\n }\n  .section-gallery {\n    display: block;\n    max-width: 1366px;\n    margin-left: auto;\n    margin-right: auto;\n    position: relative;\n    overflow: auto;\n    text-align: center;\n    padding: 60px 0px;\n }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
